import { create } from 'zustand';

import type { ProjectScope } from './project-scope';
import { listProjectWriteStatusCounts } from './project-write-outbox';

export type ProjectWriteStatusCounts = {
    pending: number;
    retryable: number;
    conflictReview: number;
    rejected: number;
};

const emptyCounts: ProjectWriteStatusCounts = {
    pending: 0,
    retryable: 0,
    conflictReview: 0,
    rejected: 0,
};

type ConflictReviewState = {
    counts: ProjectWriteStatusCounts;
    activeScopeKey: string | null;
    refreshVersion: number;
    refresh: (scope: ProjectScope | null | undefined) => Promise<void>;
    clear: () => void;
};

function toScopeKey(scope: ProjectScope): string {
    return `${scope.orgId}/${scope.projectId}`;
}

export const useConflictReviewStore = create<ConflictReviewState>((set, get) => ({
    counts: emptyCounts,
    activeScopeKey: null,
    refreshVersion: 0,
    refresh: async (scope) => {
        if (!scope) {
            set((state) => ({
                activeScopeKey: null,
                counts: emptyCounts,
                refreshVersion: state.refreshVersion + 1,
            }));
            return;
        }

        const activeScopeKey = toScopeKey(scope);
        const refreshVersion = get().refreshVersion + 1;
        set({ activeScopeKey, refreshVersion });
        const counts = await listProjectWriteStatusCounts(scope);
        const state = get();
        if (state.activeScopeKey === activeScopeKey && state.refreshVersion === refreshVersion) {
            set({ counts });
        }
    },
    clear: () => set((state) => ({
        activeScopeKey: null,
        counts: emptyCounts,
        refreshVersion: state.refreshVersion + 1,
    })),
}));
